import { render, staticRenderFns } from "./NoteDetails.vue?vue&type=template&id=9cab9eca&"
import script from "./NoteDetails.vue?vue&type=script&lang=js&"
export * from "./NoteDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports